import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import Header from '../../components/header';
import Grid from './components/grid';
import Form from './components/form';
import Content from '../../components/content';
import Notify, { ErrorProps } from '../../components/notify';
import Spinner from '../../components/spinner';
import FilePreview from '../../components/filePreview';
import { Form as FormProps, Grid as GridProps } from '../../types/common-types';

import './style.scss';

const renderForms = (formIds: string[], forms: FormProps[]) => {
  return formIds.map(formId => {
    const form = forms.find(i => i.id === formId);
    if (!form) return null;
    return <Form key={form.id} form={form} />;
  });
};

const renderGridComponents = (
  grid: { [key: string]: string[] },
  forms: FormProps[]
) => {
  const components: { [key: string]: React.ReactNode } = {};
  Object.keys(grid).forEach(pos => {
    components[pos] = renderForms(grid[pos], forms);
  });
  return components;
};

const renderNotify = (errors?: Array<ErrorProps>) => {
  if (!errors || !errors.length) return null;
  return <Notify errors={errors} />;
};

const Page: React.FC = () => {
  const page = useSelector((state: ApplicationState) => state.page);
  const { data, errors, loading, previewFile } = page;
  const { grid, forms } = data as { grid: GridProps; forms: FormProps[] };
  const { type: gridType, components: gridComp, header } = grid;
  const { class: headerType, extra: headerExtra } = header;
  const components = renderGridComponents(gridComp, forms);
  return (
    <div styleName="page">
      <Header type={headerType} extra={headerExtra} />
      <Content>
        {loading ? (
          <div styleName="page__spinner">
            <Spinner />
          </div>
        ) : null}
        {previewFile ? <FilePreview file={previewFile} /> : null}
        <div>{renderNotify(errors)}</div>
        <div styleName="page__grid">
          {Object.keys(components) ? (
            <Grid type={gridType} components={components} />
          ) : null}
        </div>
      </Content>
    </div>
  );
};

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default Page;
